import { aedsService } from "../_services";
const initialState = {
  all: {},
  items: {},
  loading: false,
  filters: {},
  admins: [],
  addressCategories: {},
  parameters: {
    field: "created",
    direction: "descending",
    aed: [],
    address: [],
    fadder: [],
    id: [],
    pageNo: 1,
    pageSize: 50
  },
  suggestions: [],
  totalItems: 0,
  totalPages: 0
};
const state = Object.assign({}, initialState);

export const tips = {
  namespaced: true,
  state: state,
  getters: {
    parameters: state => state.parameters
  },
  actions: {
    getAll: ({ commit }, payload) => {
      commit("getAllRequest");
      commit("updateParameters", payload.parameters);
      aedsService
        .getAll(payload.parameters, "tiposlist")
        .then(
          aeds => commit("getAllSuccess", aeds),
          error => commit("getAllFailure", error)
        );
      aedsService
        .getPagination(payload.parameters, "tiposlist")
        .then(
          aeds => commit("getPaginationSuccess", aeds),
          error => commit("getAllFailure", error)
        );
    },
    getFilters: ({ commit, rootState }) => {
      commit("getAllRequest");
      return aedsService.getFilters("tiposlist").then(
        filters => {
          const filterTranslations = rootState.translations.filters;
          Object.keys(filters).forEach(filterKey => {
            const group = filterTranslations[filterKey];
            if (!group || !group.options || !group.options.length) return;
            filters[filterKey] = filters[filterKey].map(option => {
              const translation = group.options.find(t => t.id === option.id);
              return translation
                ? { ...option, name: translation.name }
                : option;
            });
          });
          commit("getFilters", filters);
        },
        error => commit("getAllFailure", error)
      );
    },
    getAddressCategories: ({ commit }) => {
      commit("getAllRequest");
      aedsService.getAddressCategories().then(
        addressCategories => commit("getAddressCategories", addressCategories),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    getAdmins: ({ commit }) => {
      commit("getAllRequest");
      aedsService
        .getAdmins()
        .then(
          admins => commit("getAdmins", admins),
          error => commit("getAllFailure", error)
        );
    },
    setToUsersAEDs: ({ commit }, payload) => {
      commit("setToUsersAEDs", payload);
    },
    getSuggestions: ({ commit }, payload) => {
      aedsService
        .getSuggestions(payload)
        .then(
          data => commit("loadSuggestions", data),
          error => commit("alert/error", error, { root: true })
        );
    }
  },
  mutations: {
    getAllRequest(state) {
      state.loading = true;
    },
    getAllSuccess(state, payload) {
      //Override the api interceptor to show results while pagination is pending
      this.dispatch("loadingIndicator/hide");
      state.loading = false;
      state.items = payload;
    },
    getPaginationSuccess(state, payload) {
      state.totalItems = payload.totalItems;
      state.totalPages = payload.totalPages;
    },
    getAllFailure(state) {
      state.loading = false;
    },
    updateParameters(state, parameters) {
      state.parameters = parameters;
    },
    getFilters(state, filters) {
      state.loading = false;
      state.filters = filters;
      if (filters.isKnown && filters.isKnown.length > 0) {
        if (state.parameters.isKnown === undefined) {
          // No URL param — apply default filter value
          state.parameters = {
            ...state.parameters,
            isKnown: filters.isKnown[0].id
          };
        } else {
          // URL param was parsed as integer by updateParameters — normalize to string to match option.id
          state.parameters = {
            ...state.parameters,
            isKnown: String(state.parameters.isKnown)
          };
        }
      }
    },
    getAdmins(state, admins) {
      state.loading = false;
      state.admins = admins;
    },
    getAddressCategories(state, addressCategories) {
      state.loading = false;
      state.addressCategories = addressCategories;
    },
    setToUsersAEDs(state, userID) {
      state.parameters = {
        field: "lastUpdated",
        direction: "descending",
        aed: [],
        address: [],
        fadder: [userID],
        pageNo: 1,
        pageSize: 10
      };
    },
    loadSuggestions(state, suggestions) {
      state.suggestions = suggestions.map(({ type, name }) => ({
        name,
        type: type.charAt(0).toLowerCase() + type.slice(1)
      }));
    },
    clearSuggestions(state) {
      state.suggestions = initialState.suggestions;
    },
    resetState(state) {
      for (let prop in state) {
        state[prop] = initialState[prop];
      }
    }
  }
};
